/* eslint-disable @angular-eslint/component-selector */
import { Component, Input, DoCheck, KeyValueDiffer, ChangeDetectorRef, KeyValueDiffers, inject, input, output } from '@angular/core';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { DatatableRowDetailDirective } from '../row-detail/row-detail.directive';
import { DatatableGroupHeaderDirective } from './body-group-header.directive';

interface RowContext {
  row: unknown;
  expanded: boolean;
  rowIndex: number;
}

interface GroupContext {
  group: unknown;
  expanded: boolean;
  rowIndex: number;
}

@Component({
  selector: 'datatable-row-wrapper',
  template: `
      @if (groupHeader() && groupHeader().template) {
        <div class="datatable-group-header"
             [ngStyle]="getGroupHeaderStyle()">
          @if (groupHeader() && groupHeader().template) {
            <ng-template [ngTemplateOutlet]="groupHeader().template"
                         [ngTemplateOutletContext]="groupContext" />
          }
        </div>
      }
      @if ((groupHeader() && groupHeader().template && expanded) || !groupHeader() || !groupHeader().template) {
        <ng-content />
      }
      @if (rowDetail() && rowDetail().template && expanded) {
        <div [style.height.px]="detailRowHeight()"
             class="datatable-row-detail">
          @if (rowDetail() && rowDetail().template) {
            <ng-template [ngTemplateOutlet]="rowDetail().template"
                         [ngTemplateOutletContext]="rowContext" />
          }
        </div>
      }
    `,
  host: {
    class: 'datatable-row-wrapper',
    '(contextmenu)': 'onContextmenu($event)'
  },
  imports: [NgStyle, NgTemplateOutlet]
})
export class DataTableRowWrapperComponent implements DoCheck {
  private readonly cd = inject(ChangeDetectorRef);
  private readonly differs = inject(KeyValueDiffers);

  readonly innerWidth = input<number>(undefined);
  readonly rowDetail = input<DatatableRowDetailDirective>(undefined);
  readonly groupHeader = input<DatatableGroupHeaderDirective>(undefined);
  readonly offsetX = input<number>(undefined);
  readonly detailRowHeight = input<number>(undefined);
  readonly row = input<unknown>(undefined);
  readonly groupedRows = input<unknown>(undefined);
  readonly rowContextmenu = output<{
    event: MouseEvent;
    row: unknown;
}>();

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set rowIndex(val: number) {
    this._rowIndex = val;
    this.rowContext.rowIndex = val;
    this.groupContext.rowIndex = val;
    this.cd.markForCheck();
  }

  get rowIndex(): number {
    return this._rowIndex;
  }

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set expanded(val: boolean) {
    this._expanded = val;
    this.groupContext.expanded = val;
    this.rowContext.expanded = val;
    this.cd.markForCheck();
  }

  get expanded(): boolean {
    return this._expanded;
  }

  groupContext: GroupContext;
  rowContext: RowContext;

  private rowDiffer: KeyValueDiffer<object, object>;
  private _expanded: boolean = false;
  private _rowIndex: number;

  constructor() {
    this.groupContext = {
      group: this.row(),
      expanded: this.expanded,
      rowIndex: this.rowIndex
    };

    this.rowContext = {
      row: this.row(),
      expanded: this.expanded,
      rowIndex: this.rowIndex
    };

    this.rowDiffer = this.differs.find({}).create();
  }

  ngDoCheck(): void {
    const row = this.row();
    if (this.rowDiffer.diff(row as Record<string, object>)) {
      this.rowContext.row = row;
      this.groupContext.group = row;
      this.cd.markForCheck();
    }
  }

  onContextmenu($event: MouseEvent): void {
    this.rowContextmenu.emit({ event: $event, row: this.row() });
  }

  getGroupHeaderStyle(): Record<string, string | number> {
    const styles: Record<string, string | number> = {};

    styles['transform'] = 'translate3d(' + this.offsetX() + 'px, 0px, 0px)';
    styles['backface-visibility'] = 'hidden';
    styles['width'] = this.innerWidth();

    return styles;
  }
}
